@if(isDisabled){
    <app-loader></app-loader>
}
<div class="card">
    <div class="card-header">
        Allotment Delete
    </div>

    <div class="card-body">
        <div class="row mb-3">
            <div class="col-auto">
                <label class="mt-1">Emp Code:</label>
            </div>
            <div class="col-md-2">
                <input class="form-control" type="text" [(ngModel)]="EmpCode">
            </div>
            <div class="col-md-6">
                <input class="form-control" type="text" [(ngModel)]="EmpName" [disabled]="true">
            </div>
            <div class="col-auto">
                <button (click)="ComboLoad('EmpLoadForRegularization')" class="btn btn-outline-primary btn-sm">
                    <i class="bi bi-search"></i>Search
                </button>
            </div>
            <div class="col-auto">
                <button (click)="FilterEmployee()" class="btn btn-outline-primary btn-sm">
                    <i class="bi bi-funnel"></i>Filter
                </button>
            </div>
        </div>

        <hr>

        <div class="mt-3">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
                <thead class="table-light">
                    <tr>
                        <th>Select</th>
                        <th>TransactionID</th>
                        <th>EmpMasterID</th>
                        <th>AllotmentType</th>
                        <th>TransactionDate</th>
                        <th>EmpCode</th>
                        <th>EmpName</th>
                        <th>Designation</th>
                        <th>Duty</th>
                        <th>BranchName</th>
                        <th>FromDate</th>
                        <th>FromClient</th>
                        <th>FromSite</th>
                        <th>ToDate</th>
                        <th>ToBranch</th>
                        <th>ToClient</th>
                        <th>ToSite</th>
                        <th>ReasonName</th>
                        <th>Remarks</th>
                        <th>CreatedBy</th>
                        <th>CreatedOn</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="font-size: 11px;" *ngFor="let e of TableData ;let i = index">
                        <td>
                            <input [disabled]="i>0" type="checkbox" [(ngModel)]="e['Select']">
                        </td>
                        <td>{{e['TransactionID']}}</td>
                        <td>{{e['EmpMasterID']}}</td>
                        <td>{{e['AllotmentType']}}</td>
                        <td>{{e['TransactionDate']}}</td>
                        <td>{{e['EmpCode']}}</td>
                        <td>{{e['EmpName']}}</td>
                        <td>{{e['Designation']}}</td>
                        <td>{{e['DutyName']}}</td>
                        <td>{{e['BranchName']}}</td>
                        <td>{{e['FromDate']}}</td>
                        <td>{{e['FromClient']}}</td>
                        <td>{{e['FromSite']}}</td>
                        <td>{{e['ToDate']}}</td>
                        <td>{{e['ToBranch']}}</td>
                        <td>{{e['ToClient']}}</td>
                        <td>{{e['ToSite']}}</td>
                        <td>{{e['ReasonName']}}</td>
                        <td>{{e['Remarks']}}</td>
                        <td>{{e['CreatedBy']}}</td>
                        <td>{{e['CreatedOn']}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="card-footer">
        <div class="row">
            <div class="col"></div>
            <div class="col-auto">
                <button (click)="DeleteAllotment(TableData[0])" class="btn btn-primary btn-sm"><i class="bi bi-trash"></i> Delete</button>
            </div>
            <div class="col-auto">
                <button (click)="excelDownload()" class="btn btn-outline-primary btn-sm"><i class="bi bi-file-spreadsheet"></i> Excel</button>
            </div>
        </div>
    </div>
</div>